import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {kanMailTemplatesService} from "../../../services/services/templates";
import {MailTemplate} from "../../../../classes/mailTemplate";
import {FileLog} from "../../../../classes/fileLog";
import {kanFilesService} from "../../../services/services/files";

@Component({
    selector: 'kan-mail-template-dialog',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanMailTemplateDialog {
    public template: MailTemplate = new MailTemplate();
    public isNew: boolean = true;

    public templateForm: FormGroup;

    constructor(private dialogRef: MatDialogRef<kanMailTemplateDialog>,
                private formBuilder: FormBuilder,
                private templateService: kanMailTemplatesService,
                private fileService: kanFilesService,
                @Inject(MAT_DIALOG_DATA) private data: any) {

        if (this.data && this.data.template) {
            this.template = JSON.parse(JSON.stringify(this.data.template));
            this.isNew = false;
        }
    }

    ngOnInit(): void {
        this.templateForm = this.formBuilder.group({
            title: new FormControl(this.template.title, [Validators.required]),
            header: new FormControl(this.template.header, [Validators.required]),
            footer: new FormControl(this.template.footer, [Validators.required])
        });
    }

    public selectFile(event, field) {
        let fileLog = new FileLog();
        fileLog.type = 'MAIL';
        let input = document.createElement('input');
        input.type = 'file';
        input.click();
        input.addEventListener('change', (e) => {
            let file = input.files[0];
            this.fileService.addFileLog(fileLog, file, file.name)
                .then((fileLog) => {
                    this.template[field] = 'files/' + fileLog.file.path;
                    this.templateForm.controls[field].setErrors(null);
                })
            // let reader = new FileReader();
            // reader.readAsDataURL(file);
            // reader.onload = () => {
            //     this.template[field] = reader.result;
            //     this.templateForm.controls[field].setErrors(null);
            // };
        });
    }

    public addTemplate(event: any) {

        this.templateService.addTemplate(this.template)
            .then((note) => {
                this.dialogRef.close('add');
            })
            .catch((error) => {
                console.log(error);
            });
    }

    public updateTemplate(event: any) {

        this.templateService.updateTemplate(this.template)
            .then((note) => {
                this.dialogRef.close('update');
            })
            .catch((error) => {
                console.log(error);
            });
    }
}



// WEBPACK FOOTER //
// ./src/modules/mails/dialogs/mail-template-dialog/component.ts